import { Button } from '../../shadcn/button';

export const CtaButton: React.FC<React.ComponentProps<typeof Button>> =
  function CtaButtonComponent({ className, children, ...props }) {
    return (
      <Button size={'lg'} asChild {...props} className={className}>
        {children}
      </Button>
    );
  };
